/** ECharts 中国地图省/直辖市/自治区名称（与 echarts/map/js/china 一致） */
export const CHINA_PROVINCES = [
  '北京', '天津', '上海', '重庆',
  '河北', '山西', '辽宁', '吉林', '黑龙江',
  '江苏', '浙江', '安徽', '福建', '江西', '山东',
  '河南', '湖北', '湖南', '广东', '海南',
  '四川', '贵州', '云南', '陕西', '甘肃', '青海', '台湾',
  '内蒙古', '广西', '西藏', '宁夏', '新疆',
  '香港', '澳门', '南海诸岛'
]

/**
 * 将 addr_areas / 接口返回的省名转为 ECharts 中国地图名称
 * @param {string} provinceName
 * @returns {string}
 */
export function normalizeProvinceName(provinceName) {
  if (!provinceName) {
    return ''
  }
  let name = String(provinceName).trim()
  if (name.includes('内蒙古')) return '内蒙古'
  if (name.includes('黑龙江')) return '黑龙江'
  if (name.includes('新疆')) return '新疆'
  if (name.includes('广西')) return '广西'
  if (name.includes('西藏')) return '西藏'
  if (name.includes('宁夏')) return '宁夏'
  if (name.includes('香港')) return '香港'
  if (name.includes('澳门')) return '澳门'
  if (name.includes('南海')) return '南海诸岛'
  // 山东省 / 北京市 → 取前两字，与历史看板地图逻辑一致
  name = name.substring(0, 2)
  return name
}

/**
 * 按省汇总接口返回的省市明细
 * @param {Array<{ provinceCodeScan?: string, qty?: number }>} rows
 * @returns {Array<{ name: string, value: number }>}
 */
export function aggregateByProvince(rows) {
  const qtyByProvince = {}
  ;(rows || []).forEach((row) => {
    const name = normalizeProvinceName(row.provinceCodeScan)
    if (!name) {
      return
    }
    const qty = Number(row.qty) || 0
    qtyByProvince[name] = (qtyByProvince[name] || 0) + qty
  })
  return Object.keys(qtyByProvince).map((name) => ({
    name,
    value: qtyByProvince[name]
  }))
}

/**
 * 补全全国各省（无数据为 0），便于热力着色
 * @param {Array<{ name: string, value: number }>} mapData
 * @returns {Array<{ name: string, value: number }>}
 */
export function fillChinaProvinces(mapData) {
  return CHINA_PROVINCES.map((name) => {
    const item = (mapData || []).find((d) => d.name === name)
    return {
      name,
      value: item ? item.value : 0
    }
  })
}
